module.exports = __webpack_public_path__ + "img/pc-calendar.07129a11.svg";